import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
// import VueMeta from 'vue-meta'
import NProgress from 'nprogress/nprogress'
import store from '@store'
import routes from './routes'
import VueMeta from 'vue-meta'

import { Trans } from '@utils/translation'
import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";

Vue.use(VueMeta, {
  keyName: 'page',
})

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})
router.beforeEach(async (routeTo, routeFrom, next) => {
  if (routeTo.meta.isNullPage) {
    return next()
  } else {
    const startNProgress = () => {
      if (routeFrom.name !== null) {
        NProgress.start()
      }
    }

    const setScrollRestoration = () => {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = routeTo.meta.notScrollRestoration ? 'manual' : 'auto'
      }
    }

    startNProgress();
    setScrollRestoration();
    return next()
  }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              if (routeFrom.name === args[0].name) {
                NProgress.done()
              }

              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }

  next()
})

router.afterEach((routeTo, routeFrom) => {
  NProgress.done()
})

export default router
